module.exports = __webpack_public_path__ + "static/media/chat_space.3465a98b.png";